export default __webpack_public_path__ + "static/media/tiles.bc02eace.PNG";